export default function SiteFooter() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="mx-auto grid w-full max-w-7xl gap-8 px-4 py-12 md:px-6 md:grid-cols-4">
        <div className="md:col-span-2">
          <a href="#hero" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-book-open-fill text-lg" />
            </span>
            <span className="font-heading text-lg text-background-50">
              漫画韩国<span className="text-primary-400">下拉式</span>
            </span>
          </a>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
            专注韩国漫画阅读与追更的中文门户，聚合多家汉化组熟肉更新，提供沉浸式下拉式阅读体验。热门韩漫抢先看，每日更新不错过。
          </p>
        </div>
        <div>
          <h4 className="mb-3 text-sm font-bold text-background-50">快速导航</h4>
          <ul className="space-y-2 text-sm text-background-300">
            <li><a href="#hot" className="transition-colors hover:text-primary-300">热门连载</a></li>
            <li><a href="#category" className="transition-colors hover:text-primary-300">主题分类</a></li>
            <li><a href="#update" className="transition-colors hover:text-primary-300">最新更新</a></li>
            <li><a href="#featured" className="transition-colors hover:text-primary-300">编辑推荐</a></li>
          </ul>
        </div>
        <div>
          <h4 className="mb-3 text-sm font-bold text-background-50">关于本站</h4>
          <ul className="space-y-2 text-sm text-background-300">
            <li><a href="#about" className="transition-colors hover:text-primary-300">品牌介绍</a></li>
            <li><a href="#about" className="transition-colors hover:text-primary-300">读者口碑</a></li>
            <li><a href="#faq" className="transition-colors hover:text-primary-300">常见问题</a></li>
            <li><a href="mailto:hello@manhanlashi.com" className="transition-colors hover:text-primary-300">联系邮箱</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-background-900">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-2 px-4 py-4 text-xs text-background-400 sm:flex-row md:px-6">
          <p>© {new Date().getFullYear()} 漫画韩国下拉式 · 只为更好的韩漫阅读体验</p>
          <p>聚合汉化 · 熟肉连载 · 每日更新</p>
        </div>
      </div>
    </footer>
  );
}